import { useState } from "react";

export const usePages = ({ elemnt }) => {
  const [pages, setPages] = useState({ min: 0, max: 8, numPages: 0 });

  const pagHandler = (event) => {
    const { name, value } = event.target;
    if (name === "next" && pages.max < elemnt.length) {
      setPages({
        min: pages.min + 8,
        max: pages.max + 8,
        numPages: Number(pages.numPages) + 1,
      });
    }
    if (name === "back" && pages.min !== 0) {
      setPages({
        min: pages.min - 8,
        max: pages.max - 8,
        numPages: Number(pages.numPages) - 1,
      });
    }
    if (name === "index") {
      setPages({ min: value * 8, max: value * 8 + 8, numPages: value });
    }
  };

  const resetPages = () => {
    setPages({ min: 0, max: 8, numPages: 0 });
  };

  return {
    ...pages,
    pagHandler,
    resetPages,
  };
};
